import type { FC } from "react"

import { FILE_TYPE_MAPPING } from "../../constants"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

interface GoodsReceiptFileFormDialogProps {
  onClose: () => void
  onRefresh: () => void
  goodsReceiptId: string
}

const documentTypeOptions: Option<string>[] = Object.entries(FILE_TYPE_MAPPING).map(([value, config]) => ({
  value,
  label: config.label,
}))

export const GoodsReceiptFileFormDialog: FC<GoodsReceiptFileFormDialogProps> = ({
  onClose,
  onRefresh,
  goodsReceiptId,
}) => (
  <AttachFilesDialog
    title='Attach File'
    referenceTableName={ReferenceTableName.AdvancedGoodsReceipt}
    referenceId={goodsReceiptId}
    documentTypeOptions={documentTypeOptions}
    successMessage='Files attached'
    testIdPrefix='goods-receipt-file'
    dialogTestId='goods-receipt-file-dialog'
    onClose={onClose}
    onSuccess={onRefresh}
  />
)
